const RECIPE_URL = process.env.API_URL + '/v2/xugarhero/recipe';
const RECIPE_TAG_URL = process.env.API_URL + '/v1/recipe/tag';
const OPTIONS = { headers: { 'Content-Type': 'multipart/form-data' } };

const getRecipes = (context, lang) => {
  return new Promise((resolve, reject) => {
    context.$http.get(RECIPE_URL, {params: {lang: lang}})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getEditableRecipe = (context, id, language) => {
  return new Promise((resolve, reject) => {
    context.$http.get(RECIPE_URL + '/' + id + '/editable', {params: {lang: language}})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const addRecipe = (context, recipe) => {
  return new Promise((resolve, reject) => {
    context.$http.post(RECIPE_URL, recipe)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const addRecipeNutri = (context, recipe) => {
  return new Promise((resolve, reject) => {
    context.$http.post(RECIPE_URL + '/nutritionist', recipe)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const updateRecipe = (context, id, recipe) => {
  return new Promise((resolve, reject) => {
    context.$http.put(RECIPE_URL + '/' + id, recipe)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const removeRecipe = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(RECIPE_URL + '/' + id)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const updateImage = (context, id, image) => {
  return new Promise((resolve, reject) => {
    context.$http.put(RECIPE_URL + '/' + id + '/image', formData(image), OPTIONS)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const getPredictedScore = (context, protein, fat, carbs, fiber) => {
  return new Promise((resolve, reject) => {
    context.$http.get(RECIPE_URL + '/score/predict-with-isp', {params: {protein: protein, fat: fat, carbs: carbs, fiber: fiber}})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const formData = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return formData;
};

const getTags = (context, language) => {
  return new Promise((resolve, reject) => {
    context.$http.get(RECIPE_TAG_URL, {params: {language: language}})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getTagToEdit = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.get(RECIPE_TAG_URL + '/' + id + '/edit')
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const addTag = (context, tag) => {
  return new Promise((resolve, reject) => {
    context.$http.post(RECIPE_TAG_URL, tag)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const updateTag = (context, id, tag) => {
  return new Promise((resolve, reject) => {
    context.$http.put(RECIPE_TAG_URL + '/' + id, tag)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const removeTag = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(RECIPE_TAG_URL + '/' + id)
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getRecipeDetail = (context, id, language) => {
  return new Promise((resolve, reject) => {
    context.$http.get(RECIPE_URL + '/V2/' + id,
      { params: { lang: language } })
  .then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};


const addFavorite = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.post(RECIPE_URL + '/' + id + '/favorite')
  .then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

const removeFavorite = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.delete(RECIPE_URL + '/' + id + '/favorite')
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};


const isFavorite = (context, id, lang) => {
  return new Promise((resolve, reject) => {
    context.$http.get(RECIPE_URL + '/' + id + '/favorite')
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getFavoriteRecipes = (context, lang) => {
  return new Promise((resolve, reject) => {
    context.$http.get(RECIPE_URL + '/favorites', {params: {lang}})
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getRecipesByNutritionist = (context, lang) => {
  return new Promise((resolve, reject) => {
    context.$http.get(RECIPE_URL + '/nutritionist', { params: { lang: lang } })
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getRecipes,
  getEditableRecipe,
  addRecipe,
  updateRecipe,
  removeRecipe,
  updateImage,
  getPredictedScore,
  getTags,
  getTagToEdit,
  addTag,
  updateTag,
  removeTag,
  getRecipeDetail,
  addFavorite,
  removeFavorite,
  isFavorite,
  getFavoriteRecipes,
  getRecipesByNutritionist,
  addRecipeNutri
};



// WEBPACK FOOTER //
// ./src/brand/health/api/recipe/index.js